// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apibaseurl:'http://143.110.243.51:8070/',

  defaultPageSize: 10,
  defaultPageNumber: 1,
  defaultSortBy: 'createdDate',
  defaultSortOrder: 'DESC',
  defaultPageSizeOptions: [5, 10, 20, 50, 100]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
